import { DateTime } from "luxon";
import {
  SINGLE_FLIGHT_SEARCH_CHANGE,
  FLIGHT_SEARCH_FORM_UPDATE,
  SINGLE_FLIGHT_SEARCH_UPDATE,
  FLIGHT_SEARCH_FILTER_UPDATE,
  SINGLE_FLIGHT_FILTER_RESET_SINGLE,
  SINGLE_FLIGHT_FILTER_CHANGE,
  SINGLE_FLIGHT_SEARCH_RESET,
  SINGLE_FLIGHT_SEARCH_INIT,
  SINGLE_FLIGHT_SEARCH_LOADING,
  SINGLE_FLIGHT_SEARCH_IDLE,
} from "../actions/search/types";

const FlightSearchFiltersInitial = {
  airline: "",
  baggage: "",
  stops: "",
  flight_class: "",
  budget: 0,
  duration: 0,
  layover: -1,
  order_by: "PRD",
  outboundDepAfter: "",
  outboundArrivalAfrer: "",
  inboundDepAfter: "",
  inboundArrivalAfter: "",
};
export const FlightSearchFilters = (
  state = FlightSearchFiltersInitial,
  action
) => {
  switch (action.type) {
    case SINGLE_FLIGHT_SEARCH_LOADING: {
      return FlightSearchFiltersInitial;
    }
    case SINGLE_FLIGHT_SEARCH_RESET: {
      return FlightSearchFiltersInitial;
    }
    case SINGLE_FLIGHT_SEARCH_INIT: {
      const { values } = action;
      return { ...FlightSearchFiltersInitial, ...values };
    }
    case SINGLE_FLIGHT_FILTER_RESET_SINGLE: {
      const { key } = action;
      return { ...state, [key]: FlightSearchFiltersInitial[key] };
    }
    case SINGLE_FLIGHT_FILTER_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case FLIGHT_SEARCH_FILTER_UPDATE: {
      const { filters } = action.data;
      return { ...state, ...filters };
    }
    default:
      return state;
  }
};

const FlightSearchFormInitial = {
  origin: null,
  destination: null,
  outbound_departure: DateTime.now().plus({ days: 1 }).toISODate(),
  inbound_departure: null,
  adults: 2,
  children: 0,
  children_ages: [],
  isRoundTrip: false,
  baggage_only: false,
  stops: "",
  flight_class: "",
};
export const FlightSearchForm = (state = FlightSearchFormInitial, action) => {
  switch (action.type) {
    case FLIGHT_SEARCH_FORM_UPDATE: {
      const { form } = action;
      return { ...state, ...form };
    }
    default:
      return state;
  }
};

const FlightSearchReducerInitial = {
  flights: [],
  loading: false,
  failed: false,
  page_session_id: null,
  api_uid: null,
};
export const FlightSearchReducer = (
  state = FlightSearchReducerInitial,
  action
) => {
  switch (action.type) {
    case SINGLE_FLIGHT_SEARCH_LOADING: {
      return { ...state, loading: true };
    }
    case SINGLE_FLIGHT_SEARCH_IDLE: {
      return { ...state, loading: false };
    }
    case SINGLE_FLIGHT_SEARCH_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case SINGLE_FLIGHT_SEARCH_UPDATE: {
      const { data } = action;
      return { ...state, ...data };
    }
    default:
      return state;
  }
};
